<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>点货举报列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-select
                  v-model="form.top_class_id"
                  placeholder="请选择一级分类"
                >
                  <el-option
                    v-for="item in resData.condition.top_class_list"
                    :key="item.top_class_id"
                    :label="item.top_class_name"
                    :value="item.top_class_id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="form.sec_class_id"
                  placeholder="请选择二级分类"
                >
                  <el-option
                    v-for="item in resData.condition.sec_class_list"
                    :key="item.sec_class_id"
                    :label="item.sec_class_name"
                    :value="item.sec_class_id"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="form.pg_id" placeholder="请选择买手组">
                  <el-option
                    v-for="item in resData.condition.picker_group"
                    :key="item.pg_id"
                    :label="item.pg_name"
                    :value="item.pg_id"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="form.pgid" placeholder="请选择代采组">
                  <el-option
                    v-for="item in resData.condition.purchase_group"
                    :key="item.pgid"
                    :label="item.pgname"
                    :value="item.pgid"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="form.status_id" placeholder="请选择状态">
                  <el-option
                    v-for="item in resData.condition.status"
                    :key="item.status_id"
                    :label="item.status_name"
                    :value="item.status_id"
                  >
                  </el-option>
                </el-select>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_name"
                    placeholder="商品名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_kh"
                    placeholder="商品款号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.pici_no"
                    placeholder="批次号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="举报时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="goods_img"
              label="商品图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.goods_img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_kh"
              label="款号"
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="picker_name"
              label="买手组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="purchase_name"
              label="代采组"
            ></el-table-column>
            <el-table-column
              prop="pici_no"
              label="批次号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="top_class_name"
              label="一级分类"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sec_class_name"
              label="二级类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="举报人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="举报时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
            ></el-table-column>
            <!--<el-table-column label="操作" show-overflow-tooltip align="center">-->
            <!--<template slot-scope="scope">-->
            <!--<el-button @click="handleClick(scope.row)" type="text" size="small" v-if="scope.row.en_status == 1">作废</el-button>-->
            <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {
        list: [],
        condition: {},
      },
      form: {
        status: "",
        create_time: [],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Pici/getTallyReportList",
      status: -1,
      curPage: 1,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    check(status) {
      this.filteredForm.check_status = status;
      if (typeof this.filteredForm.multipleSelection === "undefined") {
        this.$alert("没有选中项目", "操作错误", {
          confirmButtonText: "确定",
          center: true,
        });
        return;
      }
      let alertData;
      if (status == 2) {
        alertData = "确定通过转呆账申请？";
      } else {
        alertData = "确定驳回转呆账申请？";
      }
      this.$confirm("", alertData, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      })
        .then(() => {
          this.loading = true;
          this.$http
            .post("/erp/WcgOrder/checkStagnantDebts", this.filteredForm)
            .then((res) => {
              setTimeout(() => {
                this.loading = false;
              }, 200);
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.resData = res.data.data;
                this.$message({
                  type: this.resData.msg_type,
                  message: this.resData.msg,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作!",
          });
        });
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.loading = false;
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.form.report_id = row.report_id;
      this.form.status = 2;
      this.$confirm("是否作废此条举报?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .post("/erp/Pici/updateTallyReportStatus", this.filteredForm)
            .then((res) => {
              setTimeout(() => {
                this.loading = false;
              }, 200);
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: "作废失败!",
                });
              } else {
                row.status = "无效";
                row.en_status = 2;
                this.$message({
                  type: "success",
                  message: "作废成功!",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消作废!",
          });
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/TallyReportList.vue